var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "md-layout md-alignment-top-center" }, [
    _c("div", { staticClass: "md-layout-item md-size-90" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-lg btn-secondary btn-block",
          on: { click: _vm.clickShowHiddenItemBtn }
        },
        [_vm._v(_vm._s(_vm.showHiddenItemBtnStr))]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06e19c53", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06e19c53","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/parts/ShowHiddenItemBtn.vue
// module id = null
// module chunks = 